export default function (el, htmlOptions) {
    let map,
        bounds = new google.maps.LatLngBounds(),
        mapOptions = {
            zoom: 8,
            maxZoom: 17,
            center: new google.maps.LatLng(-34.397, 150.644),
            styles: [
                {
                    "featureType": "poi",
                    "stylers": [
                        {"visibility": "off"}
                    ]
                }
            ]
        },
        markers = [],
        infoWindows = [];


    function initialize(id, data) {
        data = $.parseJSON(data);
        map = new google.maps.Map(document.getElementById(id), mapOptions);

        $.each(data, function (index, location) {
            let position = new google.maps.LatLng(location.latitude, location.longitude);

            markers[index] = new google.maps.Marker({
                map: map,
                animation: google.maps.Animation.DROP,
                position: position,
                location: location.uid,
                category: location.category
            });

            bounds.extend(position);

            infoWindows[index] = new google.maps.InfoWindow({
                content: $('#marker-' + location.uid).html()
            });

            google.maps.event.addListener(markers[index], 'click', function () {
                $.each(infoWindows, function (key, val) {
                    if (val) {
                        infoWindows[key].close();
                    }
                });
                infoWindows[index].open(map, markers[index]);
            });
        });

        map.fitBounds(bounds);

        $('#category-filter').change(function () {
            let cat = $(this).val();

            $.each(markers, function (i, marker) {
                if (cat) {
                    if (cat == marker.category) {
                        marker.setVisible(true);
                    } else {
                        marker.setVisible(false);
                    }
                } else {
                    marker.setVisible(true);
                }
            });
        });
    }

    google.maps.event.addDomListener(window, 'load', initialize('location-map-' + htmlOptions.cobjUid, htmlOptions.locations));
};
